// Shim: map theme.insurances → window.insuranceVariantIds for custom.js handlers
window.insuranceVariantIds = window.theme && theme.insurances
  ? Object.keys(theme.insurances).map(Number) : [];
window.insuranceVariants = window.theme && theme.insurancesPlans
  ? Object.entries(theme.insurancesPlans).map(([id, p]) => ({
      variantId: Number(id),
      thresholdMin: p.min || 0,
      thresholdMax: p.max || 0
    }))
  : [];
  
document.addEventListener('change', function (e) {
  const checkbox = e.target.closest('#gn-enable');
  if (!checkbox) return;

  const variantId = checkbox.getAttribute("data-id");
  const loadingBar = document.querySelector('.loading-bar');

  let animationFrame;
  let progress = 0;

  function animateProgress() {
    // Slowly increment progress up to 90% while request is pending
    if (progress < 0.9) {
      // Slow down as it approaches 90%
      progress += (0.9 - progress) * 0.03;
      if (loadingBar) {
        loadingBar.style.transform = `scaleX(${progress})`;
        loadingBar.style.opacity = '1';
      }
      animationFrame = requestAnimationFrame(animateProgress);
    }
  }

  function completeProgress() {
    cancelAnimationFrame(animationFrame);
    // Jump to 100%
    progress = 1;
    if (loadingBar) {
      loadingBar.style.transition = 'transform 0.3s ease';
      loadingBar.style.transform = 'scaleX(1)';
    }
    // Then hide after completion
    setTimeout(function () {
      if (loadingBar) {
        loadingBar.style.transition = 'opacity 0.3s ease';
        loadingBar.style.opacity = '0';
        // Reset for next use
        setTimeout(function () {
          loadingBar.style.transition = 'none';
          loadingBar.style.transform = 'scaleX(0)';
        }, 300);
      }
    }, 300);
  }

  // Reset and start
  if (loadingBar) {
    loadingBar.style.transition = 'none';
    loadingBar.style.transform = 'scaleX(0)';
    loadingBar.style.opacity = '1';
  }

  // Start animation on next frame
  requestAnimationFrame(function () {
    animateProgress();
  });

  const request = checkbox.checked
    ? fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
    : fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      });

  request
    .then(() => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .finally(() => {
      completeProgress();
    });
});



// document.addEventListener('cart:rendered', function(e) {
//    console.log('cart:rendered fired', new Date().toISOString());
//   const checkbox = document.querySelector('#pp-enable');
//   if (!checkbox || !checkbox.checked) return;

//   const cart = e.detail.cart;
//   const variantId = parseInt(checkbox.getAttribute("data-id"));

//   const existingItem = cart.items.find(item =>
//     window.insuranceVariantIds.includes(item.variant_id)
//   );

//   // Nothing to do if correct variant already in cart
//   if (existingItem && existingItem.variant_id === variantId) return;

//   syncInsuranceFromCart(cart, checkbox, variantId);
// });

// async function syncInsuranceFromCart(cart, checkbox, variantId) {
//   const existingItem = cart.items.find(item =>
//     window.insuranceVariantIds.includes(item.variant_id)
//   );

//   // Nothing to do if correct variant already in cart
//   if (existingItem && existingItem.variant_id === variantId) return;

//   const updates = {};

//   // Zero out old insurance variant
//   if (existingItem) {
//     updates[existingItem.key] = 0;
//   }

//   // Add new insurance variant  
//   updates[variantId] = 1;

//   await fetch('/cart/update.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ updates })
//   });

//   document.dispatchEvent(new CustomEvent('cart:refresh'));
// }
// Track previous cart items to detect manual insurance removal
window._insuranceAutoTriggered = false;
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const checkbox = document.querySelector('#pp-enable');

    if (
      checkbox &&
      !window._insuranceAutoTriggered &&
      !window._insuranceManuallyRemoved &&
      !checkbox.checked
    ) {
      checkbox.click();
      window._insuranceAutoTriggered = true;
    }
  }, 500); // wait for DOM/cart render
});

document.addEventListener('change', async function (e) {
  const checkbox = e.target.closest('#pp-enable');
  if (!checkbox) return;

  if (!checkbox.checked) {
    window._insuranceManuallyRemoved = true;
  } else {
    window._insuranceManuallyRemoved = false;
  }

  // Also update previousCartItems so next cart:change 
  // doesn't think insurance was "just removed"
  if (checkbox.checked) {
    window._previousCartItems = null;
  }


   console.log('pp-enable change fired', checkbox.checked, new Date().toISOString());

  if (checkbox.dataset.loading === 'true') return;
  checkbox.dataset.loading = 'true';

  const variantId = checkbox.getAttribute("data-id");
  const loadingBar = document.querySelector('.loading-bar');

  let animationFrame;
  let progress = 0;

  function animateProgress() {
    if (progress < 0.9) {
      progress += (0.9 - progress) * 0.03;
      if (loadingBar) {
        loadingBar.style.transform = `scaleX(${progress})`;
        loadingBar.style.opacity = '1';
      }
      animationFrame = requestAnimationFrame(animateProgress);
    }
  }

  function completeProgress() {
    cancelAnimationFrame(animationFrame);
    progress = 1;

    if (loadingBar) {
      loadingBar.style.transition = 'transform 0.3s ease';
      loadingBar.style.transform = 'scaleX(1)';
    }

    setTimeout(() => {
      if (loadingBar) {
        loadingBar.style.transition = 'opacity 0.3s ease';
        loadingBar.style.opacity = '0';

        setTimeout(() => {
          loadingBar.style.transition = 'none';
          loadingBar.style.transform = 'scaleX(0)';
        }, 300);
      }
    }, 300);
  }

  // Reset loading bar
  if (loadingBar) {
    loadingBar.style.transition = 'none';
    loadingBar.style.transform = 'scaleX(0)';
    loadingBar.style.opacity = '1';
  }

  requestAnimationFrame(() => animateProgress());

  try {
    // Get current cart
    const cart = await fetch('/cart.js').then(res => res.json());

    // Find existing insurance item
    const existingItem = cart.items.find(item =>
      window.insuranceVariantIds.includes(item.variant_id)
    );

    if (checkbox.checked) {

      // Remove old insurance if different
      if (existingItem && existingItem.variant_id != variantId) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: existingItem.key,
            quantity: 0
          })
        });
      }

      // Add new insurance
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

    } else {

      // Remove insurance if unchecked
      if (existingItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: existingItem.key,
            quantity: 0
          })
        });
      }
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));

  } catch (error) {
    console.error('Insurance error:', error);
  } finally {
    completeProgress();
    checkbox.dataset.loading = 'false';
  }

});


  window._previousCartItems = null;
  window._insuranceManuallyRemoved = false;

  function getCorrectInsuranceVariantId(cartTotal) {
    if (!window.insuranceVariants) return null;

    for (const insurance of window.insuranceVariants) {
      const { variantId, thresholdMin, thresholdMax } = insurance;

      if (thresholdMax < thresholdMin && cartTotal > thresholdMin) {
        return variantId;
      } else if (cartTotal > thresholdMin && cartTotal < thresholdMax) {
        return variantId;
      }
    }

    return null;
  }

window.insuranceSyncPromise = null;

window.syncInsuranceBeforeRender = async function(cart, currentSectionHtml, sectionId) {
  let resolveSyncPromise;
  window.insuranceSyncPromise = new Promise(resolve => {
    resolveSyncPromise = resolve;
  });

  try {
    const previousItems = window._previousCartItems;
    const currentItems = cart.items;

    // Detect if insurance was in cart before but not now
    const wasInsuranceInCart = previousItems && previousItems.find(item =>
      window.insuranceVariantIds.includes(item.variant_id)
    );
    const isInsuranceInCart = currentItems.find(item =>
      window.insuranceVariantIds?.includes(item.variant_id)
    );

    // Save current items for next comparison BEFORE any early returns
    window._previousCartItems = currentItems;

    // Insurance was just removed — set flag and skip re-add
    if (wasInsuranceInCart && !isInsuranceInCart) {
      window._insuranceManuallyRemoved = true;
      return currentSectionHtml;
    }

    // If insurance was manually removed previously, respect that until user re-checks
    if (window._insuranceManuallyRemoved) return currentSectionHtml;

    const checkbox = document.querySelector('#pp-enable');
    if (!checkbox || !checkbox.checked) return currentSectionHtml;

    const correctVariantId = getCorrectInsuranceVariantId(cart.total_price);
    if (!correctVariantId) return currentSectionHtml;

    const existingItem = currentItems.find(item =>
      window.insuranceVariantIds.includes(item.variant_id)
    );

    // Already correct variant in cart — nothing to do
    if (existingItem && existingItem.variant_id === correctVariantId) return currentSectionHtml;

    const updates = {};
    if (existingItem) updates[existingItem.key] = 0;
    updates[correctVariantId] = 1;

    const updatedCart = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, sections: [sectionId] })
    }).then(r => r.json());

    // Update stored items to reflect insurance addition
    window._previousCartItems = updatedCart.items ?? currentItems;

    return updatedCart.sections?.[sectionId] ?? currentSectionHtml;

  } finally {
    resolveSyncPromise();
  }
};

window._previousCartItems = null;
window._insuranceManuallyRemoved = false;

// Runs once on page load — captures initial cart state
// so first insurance removal is detected correctly
document.addEventListener('DOMContentLoaded', async function() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    window._previousCartItems = cart.items;
    console.log('Initial cart items loaded:', window._previousCartItems.length);
  } catch(e) {
    window._previousCartItems = [];
  }
});




